import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wikipedia-w': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M640 51.2L639.7 63.4C611.6 64.2 594.7 79.2 583.9 103.7 558.9 161.5 480.6 343.7 428.6 462.3H415L333.1 269.2C300.6 332.8 264.8 399.2 233.9 462.3 233.6 462.6 218.9 462.3 218.9 462 172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4 0.2 63.7 0.2 60.6-0.1 53.7-0.1 49.5H161.8V63.4C142.6 64.5 109 76.7 118.5 97.6 140.4 147.3 222.1 337.9 244.1 386.2 259.1 356.5 301.9 277 319.4 243.4 305.5 215.1 260.8 109.5 246.6 83.4 236.9 65.6 210.5 64 190.8 63.7V49.8L333.3 50.1V63.2C313.9 63.8 295.2 71 303.9 89.3 322.8 129.3 334.5 157.4 352 194 357.6 183.2 386.7 124.6 400.1 93.2 409 72.6 396.2 64.6 361.5 63.8 361.8 60.2 361.5 53.5 361.8 50.2 406.2 49.9 472.9 49.9 484.9 49.6V63.2C462.4 64 439.1 76 426.8 94.9L367.6 217.7C374 233.8 430.9 360.5 436.8 374.4L559.2 91.8C550.6 68.7 522.8 63.7 512 63.5V49.6L639.8 50.7 640 51.2z'
      }
    ]
  }
})
